import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AddLocationOverlay from "./overlay/AddLocationOverlay";

export default function StoreLocationOverlayManager() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    //const isLoggedIn = !!localStorage.getItem("token");
    const isLoginPage = location.pathname === "/login" || location.pathname === "/";

    const rawValue = localStorage.getItem("store_location_exists");
    const storeLocationExists = rawValue === "true";

    console.log("🔍 Overlay check:", {
      //isLoggedIn,
      isLoginPage,
      rawValue,
      storeLocationExists,
    });

    if (!isLoginPage && storeLocationExists === false) {
      console.log("📌 Opening overlay...");
      setIsOpen(true);
    } else {
      console.log("❌ Closing overlay...");
      setIsOpen(false);
    }
  }, [location]);

  return (
    <AddLocationOverlay
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onSaveSuccess={() => {
        localStorage.setItem("store_location_exists", "true");
        setIsOpen(false);
      }}
    />
  );
}
